import React from 'react'
import { Link } from "react-router-dom";

const CardProfile = ({ name, jobtitle, address, image, link }) => {

    return (
        <div className="flex sm-flex-row md:flex-col lg:flex-row relative text-white bg-gradient-to-b from-cardTileTop to-cardTileBottom">
            <img src={image} className="flex self-start w-[230px] h-[330px] object-cover filter grayscale sm:m-0 md:m-6 md:mb-0 lg:m-0" />
            <div className="p-6 flex-auto">
                <h2 className="section-title text-md text-white font-bold mb-4">{name}</h2>
                <p className="text-white mb-4">{jobtitle}</p>
                <div
                    className="text-white"
                    dangerouslySetInnerHTML={{ __html: address }}
                />
            </div>
            <Link to={link} className="absolute top-0 right-0 bottom-0 left-0 text-0">Read more</Link>
        </div>
    );
};

export default CardProfile;